export default {
  user: {},
  token: null,
  formObject: {},
  loadingPage: false,
  loadingRequest: false,
  notification: {},
  globalAlert: {},
  initPassword: false,
  modalShowing: false,
  isAdmin: false,
  isRoot: false,
  isApprover: false,
  settings: [],
};
